<template>
    <form :action="route('users.index')" method="get">
        <input type="hidden" name="filtered" value="true"/>
        <div class="row">
            <div class="col-md-3 col-12 p-r-0 mb-3 mb-md-0">
                <app-input
                    name="search"
                    data-testid="searchUsers"
                    placeholder="Search"
                    :value="search"
                ></app-input>
            </div>
            <button-set class="col-md-auto col-12  p-md-0 mb-3 mb-md-0">
                <app-button data-testid="usersSearchButton" type="primary" :link="route('users.index')" submit="submit">
                    <ion-icon name="search-outline"></ion-icon>
                    Search
                </app-button>
                <app-button type="light" @click="toggleAdvanced">
                    <ion-icon v-if="advancedSearch" name="caret-up-outline"></ion-icon>
                    <ion-icon v-else name="caret-down-outline"></ion-icon>
                    Advanced search
                </app-button>
            </button-set>
        </div>
        <slot v-if="advancedSearch"/>
    </form>
</template>
<script>
    export default {
        props: {
            initAdvancedSearch: {
                default: false
            },
            search: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                advancedSearch: Boolean(this.initAdvancedSearch)
            }
        },
        methods: {
            toggleAdvanced() {
                this.advancedSearch = !this.advancedSearch;
            }
        }
    }
</script>
